/* eslint-disable max-len */
import qs from 'qs';
import env from '../config/env';
import ApiService from './ApiService';
import localStorageFacade, { LocalStorageKeys } from '../utils/localStorageFacade';

const generate = (username, password) => ApiService.httpClient.post(`${env.keycloak.url}/realms/${env.keycloak.realm}/protocol/openid-connect/token`,
  qs.stringify({
    grant_type: 'password',
    client_id: `${env.keycloak.clientId}`,
    scope: 'openid',
    username,
    password,
  }),
  {
    'Content-Type': 'application/x-www-form-urlencoded',
  });

const exchangeSso = () => ApiService.httpClient.post(`${env.keycloak.url}/realms/${env.keycloak.realm}/sso/exchange`,
  undefined,
  {
    headers: {
      Authorization: `Bearer ${localStorageFacade.get(LocalStorageKeys.AUTH_TOKEN)}`,
      'Content-Type': 'application/json',
    },
    withCredentials: true,
  });

const TokenService = {
  generate,
  exchangeSso,
};

export default TokenService;
